<script>
import service from '@/service';
import * as Ladda from 'ladda';
import moment from 'moment';
import _ from 'lodash';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { parse } from 'date-fns';
import settings from '@/settings.js';

export default {
	components: {
		Loading
	},
	methods: {
		showModal: function (data) {
			/*
				nacin 1 => Dodajanje
				nacin 2 => Urejanje tistih, ki so ročno dodani
				nacin 3 => Podrobnosti
			*/
			this.createOptions();
			if (data != null) {
				if (data.source_file === 'manual') {
					this.nacin = this.NACIN_UREJANJA;
					this.itemData1 = Object.assign(this.itemData1, data);
					if (data.ogrodje !== '') {
						this.title = 'Urejanje vozila ' + data.ogrodje + ' (#' + data.id + ')';
					} else {
						this.title = 'Urejanje vozila #' + data.id;
					}
					if (this.itemData1.konto_destinacije === 'TV' || this.itemData1.konto_destinacije === 'RV0KM' || this.itemData1.konto_destinacije === 'ND') {
						this.itemData1.konto = this.itemData1.konto_destinacije;
					}
					this.itemData1.datum_prve_registracije = this.parseDbDate(this.itemData1.datum_prve_registracije, settings.dbDtFormat);
					this.itemData1.datum_kdaj_ga_lahko_prodamo = this.parseDbDate(this.itemData1.datum_kdaj_ga_lahko_prodamo, settings.dbDtFormat);
					this.itemData1.datum_kdaj_ga_moramo_prodati = this.parseDbDate(this.itemData1.datum_kdaj_ga_moramo_prodati, settings.dbDtFormat);
					this.itemData1.predvideni_mada = this.parseDbDate(this.itemData1.predvideni_mada, settings.dbDtFormat);
					this.itemData1.realni_mada = this.parseDbDate(this.itemData1.realni_mada, settings.dbDtFormat);
					this.itemData1.datum_zps = this.parseDbDate(this.itemData1.datum_zps, settings.dbDtFormat);
					this.itemData1.datum_zds = this.parseDbDate(this.itemData1.datum_zds, settings.dbDtFormat);
					this.itemData1.realni_madc = this.parseDbDate(this.itemData1.realni_madc, settings.dbDtFormat);
					this.itemData1.predvideni_madc = this.parseDbDate(this.itemData1.predvideni_madc, settings.dbDtFormat);
					this.itemData1.datum_fakturiranja = this.parseDbDate(this.itemData1.datum_fakturiranja, settings.dbDtFormat);
					this.itemData1.datum_vnosa_nk = this.parseDbDate(this.itemData1.datum_vnosa_nk, settings.dbDtFormat);
					this.itemData1.datum_ddk = this.parseDbDate(this.itemData1.datum_ddk, settings.dbDtFormat);
					this.itemData1.datum_kddk = this.parseDbDate(this.itemData1.datum_kddk, settings.dbDtFormat);
					this.itemData1.dejanski_datum_dodelitve = this.parseDbDate(this.itemData1.dejanski_datum_dodelitve, settings.dbDtFormat);
					this.itemData1.dejanski_datum_stornacije = this.parseDbDate(this.itemData1.dejanski_datum_stornacije, settings.dbDtFormat);
					this.itemData1.realni_ara = this.parseDbDate(this.itemData1.realni_ara, settings.dbDtFormat);
					this.itemData1.koncesija_datum = this.parseDbDate(this.itemData1.koncesija_datum, settings.dbDtFormat);
					this.itemData1.datum_izhoda_iz_oc = this.parseDbDate(this.itemData1.datum_izhoda_iz_oc, settings.dbDtFormat);
				} else {
					this.nacin = this.NACIN_PODROBNOSTI;
					this.itemData = data;
					if (data.ogrodje !== '') {
						this.title = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ')';
					} else {
						this.title = 'Vozilo #' + data.id;
					}
					this.itemData.content = JSON.stringify(data, null, 2);
				}
			} else {
				this.nacin = this.NACIN_DODAJANJA;
				this.title = 'Dodajanje vozila';
				this.itemData1.source_file = 'manual';
			}
			this.$refs.modal.show();
		},
		parseDbDate: function (value) {
			if (value) {
				return parse(value, settings.dbDtFormat);
			}
			return '';
		},
		clearModal: function () {
			this.itemData1.id = null;
			this.itemData1.ogrodje = '';
			this.itemData1.vozilo = '';
			this.itemData1.st_narocila_vozila = '';
			this.itemData1.st_narocila_kupca = '';
			this.itemData1.libelle_modele = '';
			this.itemData1.libelle_version = '';
			this.itemData1.libelle_options = '';
			this.itemData1.libelle_teinte = '';
			this.itemData1.libelle_harmonie = '';
			this.itemData1.libelle_sellerie = '';
			this.itemData1.source_file = 'manual';
			this.itemData1.st_nm = '';
			this.itemData1.konto_lastnika = '';
			this.itemData1.drzava_fiche_gamme = '';
			this.itemData1.tip_narocila_vozila = '';
			this.itemData1.vozilo_na_borzi = '';
			this.itemData1.obljubljeni_mada = '';
			this.itemData1.predvideni_mada = '';
			this.itemData1.staranje = '';
			this.itemData1.realni_mada = '';
			this.itemData1.stanje_napredovanja = '';
			this.itemData1.opomba_vozilo = '';
			this.itemData1.model = '';
			this.itemData1.verzija = '';
			this.itemData1.opcije = '';
			this.itemData1.barva = '';
			this.itemData1.notranjost = '';
			this.itemData1.oblazinjenje = '';
			this.itemData1.nivo_kvalitete = '';
			this.itemData1.sprememba = '';
			this.itemData1.datum_zps = '';
			this.itemData1.datum_zds = '';
			this.itemData1.konto_naslovnika = '';
			this.itemData1.koda_prodajalca = '';
			this.itemData1.realni_madc = '';
			this.itemData1.predvideni_madc = '';
			this.itemData1.pristanisce_vkrcanja = '';
			this.itemData1.ime_ladje = '';
			this.itemData1.rezervirano_vozilo = '';
			this.itemData1.maskirano_vozilo = '';
			this.itemData1.skrito_vozilo = '';
			this.itemData1.viop = '';
			this.itemData1.datum_fakturiranja = '';
			this.itemData1.datum_vnosa_nk = '';
			this.itemData1.datum_ddk = '';
			this.itemData1.datum_kddk = '';
			this.itemData1.kupec = '';
			this.itemData1.konto_agenta_satelita = '';
			this.itemData1.konto_destinacije = '';
			this.itemData1.koda_prod = '';
			this.itemData1.dejanski_datum_dodelitve = '';
			this.itemData1.dejanski_datum_stornacije = '';
			this.itemData1.tip_kupca = '';
			this.itemData1.prodajni_kanal = '';
			this.itemData1.tip_nm = '';
			this.itemData1.ime = '';
			this.itemData1.email = '';
			this.itemData1.telefon_privatni = '';
			this.itemData1.st_pogodbe_v_advensysu = '';
			this.itemData1.stanje_narocila_kupca = '';
			this.itemData1.status_kvalitete = '';
			this.itemData1.realni_ara = '';
			this.itemData1.nef = '';
			this.itemData1.ddo = '';
			this.itemData1.ddpp = '';
			this.itemData1.blocage_financier = '';
			this.itemData1.blokada_komerciale = '';
			this.itemData1.blokada_cata = '';
			this.itemData1.blokada_kvalitete = '';
			this.itemData1.pgeo_bcv = '';
			this.itemData1.koncesija_lokacija = '';
			this.itemData1.koncesija_datum = '';
			this.itemData1.koncesija_prodajalec = '';
			this.itemData1.zadrzano_lastnik = '';
			this.itemData1.interna_opomba = '';
			this.itemData1.akcijski = '';
			this.itemData1.datum_izhoda_iz_oc = '';
			this.itemData1.opomba_narocilo_kupca = '';
			this.itemData1.konto = '';
			this.itemData1.datum_prve_registracije = '';
			this.itemData1.datum_kdaj_ga_lahko_prodamo = '';
			this.itemData1.datum_kdaj_ga_moramo_prodati = '';
			this.itemData1.st_kilometrov = '';
			this.itemData1.prodajna_cena = null;
			this.prodajalci_selected = null;
			this.prodajalci_options = null;
			this.vozilo_arhivirano = true;
		},
		resetModal: function () {
			this.clearModal();
			this.itemData = {};
			this.title = '';
			this.itemData.content = '';
			this.message = {
				type: null,
				text: null
			};
			this.ogrodja_options = [];
			this.nacin = this.NACIN_NEZNAN;
		},
		modal_okClick: function (evt) {
			evt.preventDefault()
			if (this.nacin === this.NACIN_PODROBNOSTI) {
				this.$refs.modal.hide();
			} else if (this.nacin === this.NACIN_UREJANJA || this.nacin === this.NACIN_DODAJANJA) {
				if (this.validateForm) {
					if (this.prodajalci_selected != null) {
						this.itemData1.koncesija_prodajalec = this.prodajalci_selected.id;
					}
					if (this.itemData1.obljubljeni_mada == null) {
						this.itemData1.obljubljeni_mada = '';
					}
					this.showError(null);
					let loader = Ladda.create(this.$refs.aOk);
					loader.start();
					service.saveVozilo(this.itemData1)
						.then(response => {
							loader.stop();
							if (response['message'] === 'edited') {
								this.$emit('importdata_edit', response['importdata']);
								this.$refs.modal.hide();
							} else if (response['message'] === 'added') {
								this.$emit('importdata_add', response['importdata']);
								this.$refs.modal.hide();
							} else {
								this.showError('Neveljaven odziv strežnika!');
								console.error('Neveljaven response message: ' + response['message']);
							}
						})
						.catch(error => {
							loader.stop();
							if (error.response) {
								// Request made and server responded
								if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
									this.showError('Napaka pri validaciji na strežniku!');
									console.error(error.response.data.message + ': ', error.response.data.errors);
								} else if (error.response.data.message === settings.errorMessages.notSavedError) {
									this.showError('Napaka pri shranjevanju!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === settings.errorMessages.PDOException) {
									this.showError('Napaka na strežniku!');
									console.error(error.response.data.message);
								} else {
									this.showError('Neznana napaka na strežniku!');
									console.error(error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								console.log('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								console.log('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				} else {
					this.showError('Označena polja so nepravino izpolnjena!');
				}
			} else {
				this.showError('Neznan način uporabe modala!');
			}
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		modal_cancelClick: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.resetModal();
			}, 300);
		},
		loadProdajalci: function () {
			this.prodajalci_options = [];
			service.getProdajalci()
				.then(prodajalci => {
					for (let item of prodajalci) {
						item.full_name = item.first_name + ' ' + item.last_name;
					}
					this.prodajalci_options = prodajalci;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		createOptions: function () {
			let wOptions = [];
			let week = moment().week();
			let year = moment().year();
			let weeksInYear = this.weeksInYear(year);
			let numOptions = 52;
			let numWeeksInPreviusYear = this.weeksInYear(year - 1);
			for (let i = 0; i <= numOptions; i++) {
				let tmpWeek = week - (numOptions / 2) + i;
				if (tmpWeek > weeksInYear) {
					tmpWeek = tmpWeek - numOptions - 1;
					let nextYear = year + 1;
					wOptions.push(tmpWeek + '/' + nextYear);
				} else if (tmpWeek <= 0) {
					tmpWeek = numWeeksInPreviusYear - Math.abs(tmpWeek);
					let previusYear = year - 1;
					wOptions.push(tmpWeek + '/' + previusYear);
				} else {
					wOptions.push(tmpWeek + '/' + year);
				}
			}
			this.weeks_options = wOptions;
			this.current_week = moment().week();
		},
		weeksInYear: function (year) {
			return Math.max(moment(new Date(year, 11, 31)).isoWeek(), moment(new Date(year, 11, 31 - 7)).isoWeek());
		},
		vozilaSelect_load: _.debounce((loading, search, vm) => {
			loading(true);
			service.searchVozila(search)
				.then(vozila => {
					vozila = [...new Set(vozila.map(item => item.ogrodje))];
					vm.ogrodja_options = vozila;
					loading(false);
				})
				.catch(error => {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
		}, 500),
		voziloSelect_change: function (ogrodje) {
			this.clearModal();
			if (ogrodje == null) {
				this.ogrodja_options = [];
				this.showError();
				return '';
			} else if (this.ogrodja_options.find(element => element === ogrodje)) {
				this.isLoading = true;
				service.getImportdataDistinctByOgrodje(ogrodje)
					.then(response => {
						if (response.status === 'ok') {
							this.itemData1.ogrodje = ogrodje;
							this.predizpolniModal(response.importdata);
						} else {
							this.showError('Napaka pri pridobivanju podatkov (importdata ne obstaja)');
						}
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.showError('Napaka pri pridobivanju podatkov');
						if (error) {
							console.log(error);
						}
					});
			} else {
				this.itemData1.ogrodje = ogrodje;
			}
		},
		vozilaSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		predizpolniModal: function (importdata) {
			// admin params
			this.itemData1.vozilo = importdata.vozilo;
			if (importdata.archived_on == null) {
				this.showError('Vozilo še ni bilo arhivirano in ga ni mogoče dodati');
				this.vozilo_arhivirano = false;
			} else {
				this.vozilo_arhivirano = true;// import params
				this.itemData1.st_narocila_vozila = importdata.st_narocila_vozila;
				this.itemData1.konto_lastnika = importdata.konto_lastnika;
				this.itemData1.tip_narocila_vozila = importdata.tip_narocila_vozila;
				this.itemData1.vozilo_na_borzi = importdata.vozilo_na_borzi;
				this.itemData1.obljubljeni_mada = importdata.obljubljeni_mada;
				this.itemData1.predvideni_mada = importdata.predvideni_mada; // datum
				this.itemData1.predvideni_mada_ts = importdata.predvideni_mada_ts; // datum timestamp
				this.itemData1.staranje = importdata.staranje;
				this.itemData1.realni_mada = importdata.realni_mada; // datum
				this.itemData1.realni_mada_ts = importdata.realni_mada_ts; // datum timestamp
				this.itemData1.libelle_modele = importdata.libelle_modele;
				this.itemData1.libelle_version = importdata.libelle_version;
				this.itemData1.libelle_options = importdata.libelle_options;
				this.itemData1.libelle_teinte = importdata.libelle_teinte;
				this.itemData1.libelle_harmonie = importdata.libelle_harmonie;
				this.itemData1.libelle_sellerie = importdata.libelle_sellerie;
				this.itemData1.drzava_fiche_gamme = importdata.drzava_fiche_gamme;
				this.itemData1.model = importdata.model;
				this.itemData1.verzija = importdata.verzija;
				this.itemData1.opcije = importdata.opcije;
				this.itemData1.barva = importdata.barva;
				this.itemData1.notranjost = importdata.notranjost;
				this.itemData1.oblazinjenje = importdata.oblazinjenje;
				this.itemData1.nivo_kvalitete = importdata.nivo_kvalitete;
				this.itemData1.sprememba = importdata.sprememba;
				this.itemData1.datum_zps = importdata.datum_zps; // datum
				this.itemData1.datum_zds = importdata.datum_zds; // datum
				this.itemData1.stanje_napredovanja = importdata.stanje_napredovanja;
				this.itemData1.konto_destinacije = importdata.konto_destinacije;
				this.itemData1.koda_prodajalca = importdata.koda_prodajalca;
				this.itemData1.realni_madc = importdata.realni_madc; // datum
				this.itemData1.realni_madc_ts = importdata.realni_madc_ts; // datum timestamp
				this.itemData1.predvideni_madc = importdata.predvideni_madc; // datum
				this.itemData1.predvideni_madc_ts = importdata.predvideni_madc_ts; // datum timestamp
				this.itemData1.pristanisce_vkrcanja = importdata.pristanisce_vkrcanja;
				this.itemData1.ime_ladje = importdata.ime_ladje;
				this.itemData1.rezervirano_vozilo = importdata.rezervirano_vozilo;
				this.itemData1.maskirano_vozilo = importdata.maskirano_vozilo;
				this.itemData1.skrito_vozilo = importdata.skrito_vozilo;
				this.itemData1.opomba_vozilo = importdata.opomba_vozilo;
				this.itemData1.datum_fakturiranja = importdata.datum_fakturiranja; // datum
				this.itemData1.datum_izhoda_iz_oc = importdata.datum_izhoda_iz_oc; // datum
				this.itemData1.source_file = 'manual';
			}
		}
	},
	data: function () {
		return {
			NACIN_NEZNAN: 0,
			NACIN_DODAJANJA: 1,
			NACIN_UREJANJA: 2,
			NACIN_PODROBNOSTI: 3,
			nacin: this.NACIN_NEZNAN,
			title: '',
			itemData: {
				content: ''
			},
			itemData1: {
				id: null,
				ogrodje: '',
				vozilo: '',
				st_narocila_vozila: '',
				st_narocila_kupca: '',
				libelle_modele: '',
				libelle_version: '',
				libelle_options: '',
				libelle_teinte: '',
				libelle_harmonie: '',
				libelle_sellerie: '',
				source_file: '',
				st_nm: '',
				konto_lastnika: '',
				drzava_fiche_gamme: '',
				tip_narocila_vozila: '',
				vozilo_na_borzi: '',
				obljubljeni_mada: '',
				predvideni_mada: '',
				staranje: '',
				realni_mada: '',
				stanje_napredovanja: '',
				opomba_vozilo: '',
				model: '',
				verzija: '',
				opcije: '',
				barva: '',
				notranjost: '',
				oblazinjenje: '',
				nivo_kvalitete: '',
				sprememba: '',
				datum_zps: '',
				datum_zds: '',
				konto_naslovnika: '',
				koda_prodajalca: '',
				realni_madc: '',
				predvideni_madc: '',
				pristanisce_vkrcanja: '',
				ime_ladje: '',
				rezervirano_vozilo: '',
				maskirano_vozilo: '',
				skrito_vozilo: '',
				viop: '',
				datum_fakturiranja: '',
				datum_vnosa_nk: '',
				datum_ddk: '',
				datum_kddk: '',
				kupec: '',
				konto_agenta_satelita: '',
				konto_destinacije: '',
				koda_prod: '',
				dejanski_datum_dodelitve: '',
				dejanski_datum_stornacije: '',
				tip_kupca: '',
				prodajni_kanal: '',
				tip_nm: '',
				ime: '',
				email: '',
				telefon_privatni: '',
				st_pogodbe_v_advensysu: '',
				stanje_narocila_kupca: '',
				status_kvalitete: '',
				realni_ara: '',
				nef: '',
				ddo: '',
				ddpp: '',
				blocage_financier: '',
				blokada_komerciale: '',
				blokada_cata: '',
				blokada_kvalitete: '',
				pgeo_bcv: '',
				koncesija_lokacija: '',
				koncesija_datum: '',
				koncesija_prodajalec: '',
				zadrzano_lastnik: '',
				interna_opomba: '',
				akcijski: '',
				opomba_narocilo_kupca: '',
				datum_izhoda_iz_oc: '',
				konto: '',
				datum_prve_registracije: '',
				datum_kdaj_ga_lahko_prodamo: '',
				datum_kdaj_ga_moramo_prodati: '',
				st_kilometrov: '',
				prodajna_cena: null
			},
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			prodajalci_selected: null,
			prodajalci_options: null,
			weeks_options: null,
			current_week: null,
			ogrodja_options: [],
			isLoading: false,
			vozilo_arhivirano: true
		}
	},
	computed: {
		ok_text () {
			if (this.nacin === this.NACIN_DODAJANJA) {
				return 'Dodaj';
			}
			if (this.nacin === this.NACIN_UREJANJA) {
				return 'Shrani';
			}
			if (this.nacin === this.NACIN_PODROBNOSTI) {
				return 'Zapri';
			}
		},
		state_ogrodje () {
			if (this.itemData1.ogrodje.length > 0 && this.itemData1.ogrodje.length <= 20 && this.vozilo_arhivirano) {
				this.showError();
				return true;
			}
			return false;
		},
		invalidFeedback_ogrodje () {
			if (this.itemData1.hasOwnProperty('ogrodje')) {
				if (this.itemData1.ogrodje.length > 20) {
					return 'Ogrodje lahko vsebuje največ 20 znakov';
				} if (this.itemData1.ogrodje.length < 1) {
					return 'Ogrodje je obvezno';
				} else {
					return '';
				}
			}
			return 'Ogrodje je obvezno';
		},
		state_tip_narocila_vozila () {
			if (this.itemData1.tip_narocila_vozila.length <= 5) {
				this.showError();
				return true;
			}
			return false;
		},
		invalidFeedback_tip_narocila_vozila () {
			if (this.itemData1.tip_narocila_vozila.length > 5) {
				return 'Največ 5 znakov';
			} else {
				return '';
			}
		},
		vsiProdajalci () {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		},
		validateForm: function () {
			if (this.state_ogrodje) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" id="infoModal" @hide="resetModal" :title="title" size="lg" >
		<loading :active.sync="isLoading"></loading>
		<b-tabs>
			<form>
				<b-tab title="Osnovni podatki" active>
					<b-row v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA">
						<b-col cols="6">
							<b-form-group
								label="Ogrodje"
								label-for="input-ogrodje"
								:invalid-feedback="invalidFeedback_ogrodje"
								:state="state_ogrodje">
								<v-select v-model="itemData1.ogrodje"
									id="ogrodje" 
									label="ogrodje"
									:options="ogrodja_options"
									:taggable="true"
									:filterable="false"
									:disabled="nacin === NACIN_UREJANJA"
									@input="voziloSelect_change($event)"
									@search="vozilaSelect_search"
									placeholder="Izberi vozilo ...">
									<template slot="no-options">Vnesite VIN številko vozila</template>
								</v-select>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group b-form-group label="Prodajna cena:">
								<currency-input v-model="itemData1.prodajna_cena" class="form-control"/>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group
								label="Konto"
								label-for="input-konto">
								<select v-model="itemData1.konto" class="custom-select mr-sm-2" id="input-konto">
    								<option value="" selected>Izberite konto</option>
									<option value="TV">TV</option>
									<option value="RV0KM">RV0KM</option>
									<option value="ND">ND</option>
									<option value="900089">900089</option>
									<option value="900033">900033</option>
									<option value="906089">906089</option>
									<option value="100003">100003</option>
									<option value="106003">106003</option>
									<option value="KIA">KIA</option>
									<option value="MG">MG</option>
									<option value="NISSAN">NISSAN</option>
								</select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-else>
						<b-col cols="12">
							<b-form-group>
								<label for="input-ogrodje">Ogrodje</label>
								<b-form-input type="text" id="input-ogrodje" v-model="itemData.ogrodje" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA">
						<b-col sm="3">
							<b-form-group label="Datum prve registracije" label-for="input-datum_prve_registracije">
								<v-date-picker
									ref="datum_prve_registracije"
									id="input-datum_prve_registracije"
									v-model="itemData1.datum_prve_registracije"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Prodamo ga lahko od" label-for="input-datum_kdaj_ga_lahko_prodamo">
								<v-date-picker
									ref="datum_kdaj_ga_lahko_prodamo"
									id="input-datum_kdaj_ga_lahko_prodamo"
									v-model="itemData1.datum_kdaj_ga_lahko_prodamo"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Prodati ga moramo do" label-for="input-datum_kdaj_ga_moramo_prodati">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_kdaj_ga_moramo_prodati"
									id="input-datum_kdaj_ga_moramo_prodati"
									v-model="itemData1.datum_kdaj_ga_moramo_prodati"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Št. kilometrov"
								label-for="input-st_kilometrov">
								<b-form-input type="number" id="input-st_kilometrov" v-model="itemData1.st_kilometrov"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group label="Št. naročila vozila"
								label-for="input-st_narocila_vozila">
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-st_narocila_vozila" v-model="itemData1.st_narocila_vozila"></b-form-input>
								<b-form-input v-else type="text" id="input-st_narocila_vozila" :value="itemData.st_narocila_vozila" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-st_narocila_kupca">Št. naročila kupca</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-st_narocila_kupca" v-model="itemData1.st_narocila_kupca"></b-form-input>
								<b-form-input v-else type="text" id="input-st_narocila_kupca" :value="itemData.st_narocila_kupca" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group label="Model"
								label-for="input-libelle_modele">
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-libelle_modele" v-model="itemData1.libelle_modele"></b-form-input>
								<b-form-input v-else type="text" id="input-libelle_modele" :value="itemData.libelle_modele" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="8">
							<b-form-group label="Verzija"
								label-for="input-libelle_version">
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-libelle_version" v-model="itemData1.libelle_version"></b-form-input>
								<b-form-input v-else type="text" id="input-libelle_version" :value="itemData.libelle_version" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-form-group label="Opcije"
						label-for="input-libelle_options">
						<b-form-textarea v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" :rows="2" :max-rows="6" type="text" id="input-libelle_options" v-model="itemData1.libelle_options"></b-form-textarea>
						<b-form-textarea v-else :rows="2" :max-rows="6" type="text" id="input-libelle_options" :value="itemData.libelle_options" readonly></b-form-textarea>
					</b-form-group>
					<b-row>
						<b-col sm="6">
							<b-form-group label="Barva"
								label-for="input-libelle_teinte">
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-libelle_teinte" v-model="itemData1.libelle_teinte"></b-form-input>
								<b-form-input v-else type="text" id="input-libelle_teinte" :value="itemData.libelle_teinte" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group label="Notranjost"
								label-for="input-libelle_harmonie">
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-libelle_harmonie" v-model="itemData1.libelle_harmonie"></b-form-input>
								<b-form-input v-else type="text" id="input-libelle_harmonie" :value="itemData.libelle_harmonie" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-form-group label="Oblazinjenje"
						label-for="input-libelle_sellerie">
						<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-libelle_sellerie" v-model="itemData1.libelle_sellerie"></b-form-input>
						<b-form-input v-else type="text" id="input-libelle_sellerie" :value="itemData.libelle_sellerie" readonly></b-form-input>
					</b-form-group>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-created_at">Datum vnosa</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-created_at" v-model="itemData1.created_at" readonly></b-form-input>
								<b-form-input v-else type="text" id="input-created_at" v-model="itemData.created_at" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-updated_at">Datum spremembe</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-updated_at" v-model="itemData1.updated_at" readonly></b-form-input>
								<b-form-input v-else type="text" id="input-updated_at" v-model="itemData.updated_at" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-source_file">Vir</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-source_file" v-model="itemData1.source_file" readonly></b-form-input>
								<b-form-input v-else type="text" id="input-source_file" v-model="itemData.source_file" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
				</b-tab>
				<b-tab title="Podrobnosti 1">
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-st_nm">Št. nm</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-st_nm" v-model="itemData1.st_nm"></b-form-input>
								<b-form-input v-else type="text" id="input-st_nm" :value="itemData.st_nm" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-konto_lastnika">Konto lastnika</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-konto_lastnika" v-model="itemData1.konto_lastnika"></b-form-input>
								<b-form-input v-else type="text" id="input-konto_lastnika" :value="itemData.konto_lastnika" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-drzava_fiche_gamme">Država</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-drzava_fiche_gamme" v-model="itemData1.drzava_fiche_gamme"></b-form-input>
								<b-form-input v-else type="text" id="input-drzava_fiche_gamme" :value="itemData.drzava_fiche_gamme" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" 
								label="Tip naročila vozila"
								label-for="input-tip_narocila_vozila"
								:invalid-feedback="invalidFeedback_tip_narocila_vozila"
								:state="state_tip_narocila_vozila">
								<b-form-input type="text" id="input-tip_narocila_vozila" v-model="itemData1.tip_narocila_vozila" trim></b-form-input>
							</b-form-group>
							<b-form-group v-else>
								<label for="input-tip_narocila_vozila">Tip naročila vozila</label>
								<b-form-input type="text" id="input-tip_narocila_vozila" :value="itemData.tip_narocila_vozila" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-vozilo_na_borzi">Vozilo na borzi</label>
								<select v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" v-model="itemData1.vozilo_na_borzi" class="custom-select mr-sm-2" id="input-vozilo_na_borzi">
    								<option value="" selected>Izberite</option>
									<option value="Da">Da</option>
									<option value="Ne">Ne</option>
								</select>
								<b-form-input v-else type="text" id="input-vozilo_na_borzi" :value="itemData.vozilo_na_borzi" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group
								id="fieldset-obljubljeni_mada"
								label="Obljubljeni mada"
								label-for="obljubljeni_mada">
								<v-select id="input-obljubljeni_mada"
										v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
										v-model="itemData1.obljubljeni_mada"
										:options="weeks_options"
										placeholder="Izberi teden ..."
										hint="Danes je"
										persistent-hint>
								</v-select>
								<b-form-input v-else type="text" id="input-obljubljeni_mada" :value="itemData.obljubljeni_mada" readonly></b-form-input>
								<span v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA">Smo v {{ current_week }} tednu.</span>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Predvideni mada" label-for="input-predvideni_mada">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="predvideni_mada"
									id="input-predvideni_mada"
									v-model="itemData1.predvideni_mada"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-predvideni_mada" :value="itemData.predvideni_mada" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-staranje">Staranje</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-staranje" v-model="itemData1.staranje"></b-form-input>
								<b-form-input v-else type="text" id="input-staranje" :value="itemData.staranje" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Realni mada" label-for="input-realni_mada">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="realni_mada"
									id="input-realni_mada"
									v-model="itemData1.realni_mada"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-realni_mada" :value="itemData.realni_mada" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-stanje_napredovanja">Stanje napredovanja</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-stanje_napredovanja" v-model="itemData1.stanje_napredovanja"></b-form-input>
								<b-form-input v-else type="text" id="input-stanje_napredovanja" :value="itemData.stanje_napredovanja" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-opomba_vozilo">Opomba vozila</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-opomba_vozilo" v-model="itemData1.opomba_vozilo"></b-form-input>
								<b-form-input v-else type="text" id="input-opomba_vozilo" :value="itemData.opomba_vozilo" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-model">Model</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-model" v-model="itemData1.model"></b-form-input>
								<b-form-input v-else type="text" id="input-model" :value="itemData.model" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-verzija">Verzija</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-verzija" v-model="itemData1.verzija"></b-form-input>
								<b-form-input v-else type="text" id="input-verzija" :value="itemData.verzija" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-opcije">Opcije</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-opcije" v-model="itemData1.opcije"></b-form-input>
								<b-form-input v-else type="text" id="input-opcije" :value="itemData.opcije" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-barva">Barva</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-barva" v-model="itemData1.barva"></b-form-input>
								<b-form-input v-else type="text" id="input-barva" :value="itemData.barva" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-notranjost">Notranjost</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-notranjost" v-model="itemData1.notranjost"></b-form-input>
								<b-form-input v-else type="text" id="input-notranjost" :value="itemData.notranjost" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-oblazinjenje">Oblazinjenje</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-oblazinjenje" v-model="itemData1.oblazinjenje"></b-form-input>
								<b-form-input v-else type="text" id="input-oblazinjenje" :value="itemData.oblazinjenje" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group>
								<label for="input-nivo_kvalitete">Nivo kvalitete</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-nivo_kvalitete" v-model="itemData1.nivo_kvalitete"></b-form-input>
								<b-form-input v-else type="text" id="input-nivo_kvalitete" :value="itemData.nivo_kvalitete" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-sprememba">Sprememba</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-sprememba" v-model="itemData1.sprememba"></b-form-input>
								<b-form-input v-else type="text" id="input-sprememba" :value="itemData.sprememba" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Datum ZPS" label-for="input-datum_zps">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_zps"
									id="input-datum_zps"
									v-model="itemData1.datum_zps"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_zps" :value="itemData.datum_zps" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Datum ZDS" label-for="input-datum_zds">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_zds"
									id="input-datum_zds"
									v-model="itemData1.datum_zds"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_zds" :value="itemData.datum_zds" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-konto_naslovnika">Konto naslovnika</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-konto_naslovnika" v-model="itemData1.konto_naslovnika"></b-form-input>
								<b-form-input v-else type="text" id="input-konto_naslovnika" :value="itemData.konto_naslovnika" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-koda_prodajalca">Koda prodajalca</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-koda_prodajalca" v-model="itemData1.koda_prodajalca"></b-form-input>
								<b-form-input v-else type="text" id="input-koda_prodajalca" :value="itemData.koda_prodajalca" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group label="Realni madc" label-for="input-realni_madc">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="realni_madc"
									id="input-realni_madc"
									v-model="itemData1.realni_madc"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-realni_madc" :value="itemData.realni_madc" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group label="Predvideni madc" label-for="input-predvideni_madc">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="predvideni_madc"
									id="input-predvideni_madc"
									v-model="itemData1.predvideni_madc"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-predvideni_madc" :value="itemData.predvideni_madc" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
				</b-tab>
				<b-tab title="Podrobnosti 2">
					<b-row>
						<b-col sm="6">
							<b-form-group>
								<label for="input-pristanisce_vkrcanja">Pristanišče vkrcanja</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-pristanisce_vkrcanja" v-model="itemData1.pristanisce_vkrcanja"></b-form-input>
								<b-form-input v-else type="text" id="input-pristanisce_vkrcanja" :value="itemData.pristanisce_vkrcanja" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group>
								<label for="input-ime_ladje">Ime ladje</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-ime_ladje" v-model="itemData1.ime_ladje"></b-form-input>
								<b-form-input v-else type="text" id="input-ime_ladje" :value="itemData.ime_ladje" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group>
								<label for="input-rezervirano_vozilo">Rezervirano vozilo</label>
								<select v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" v-model="itemData1.rezervirano_vozilo" class="custom-select mr-sm-2" id="input-rezervirano_vozilo">
    								<option value="" selected>Izberite</option>
									<option value="Da">Da</option>
									<option value="Ne">Ne</option>
								</select>
								<b-form-input v-else type="text" id="input-rezervirano_vozilo" :value="itemData.rezervirano_vozilo" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-maskirano_vozilo">Maskirano vozilo</label>
								<select v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" v-model="itemData1.maskirano_vozilo" class="custom-select mr-sm-2" id="input-maskirano_vozilo">
    								<option value="" selected>Izberite</option>
									<option value="Da">Da</option>
									<option value="Ne">Ne</option>
								</select>
								<b-form-input v-else type="text" id="input-maskirano_vozilo" :value="itemData.maskirano_vozilo" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-skrito_vozilo">Skrito vozilo</label>
								<select v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" v-model="itemData1.skrito_vozilo" class="custom-select mr-sm-2" id="input-skrito_vozilo">
    								<option value="" selected>Izberite</option>
									<option value="Da">Da</option>
									<option value="Ne">Ne</option>
								</select>
								<b-form-input v-else type="text" id="input-skrito_vozilo" :value="itemData.skrito_vozilo" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-viop">VIOP</label>
								<select v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" v-model="itemData1.viop" class="custom-select mr-sm-2" id="input-viop">
    								<option value="" selected>Izberite</option>
									<option value="Da">Da</option>
									<option value="Ne">Ne</option>
								</select>
								<b-form-input v-else type="text" id="input-viop" :value="itemData.viop" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group label="Datum fakturiranja" label-for="input-datum_fakturiranja">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_fakturiranja"
									id="input-datum_fakturiranja"
									v-model="itemData1.datum_fakturiranja"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_fakturiranja" :value="itemData.datum_fakturiranja" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Datum vnosa NK" label-for="input-datum_vnosa_nk">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_vnosa_nk"
									id="input-datum_vnosa_nk"
									v-model="itemData1.datum_vnosa_nk"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_vnosa_nk" :value="itemData.datum_vnosa_nk" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Datum DDK" label-for="input-datum_ddk">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_ddk"
									id="input-datum_ddk"
									v-model="itemData1.datum_ddk"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_ddk" :value="itemData.datum_ddk" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Datum KDDK" label-for="input-datum_kddk">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_kddk"
									id="input-datum_kddk"
									v-model="itemData1.datum_kddk"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_kddk" :value="itemData.datum_kddk" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-kupec">Kupec</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-kupec" v-model="itemData1.kupec"></b-form-input>
								<b-form-input v-else type="text" id="input-kupec" :value="itemData.kupec" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-konto_agenta_satelita">Konto agenta satelita</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-konto_agenta_satelita" v-model="itemData1.konto_agenta_satelita"></b-form-input>
								<b-form-input v-else type="text" id="input-konto_agenta_satelita" :value="itemData.konto_agenta_satelita" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-konto_destinacije">Konto destinacije</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-konto_destinacije" v-model="itemData1.konto_destinacije"></b-form-input>
								<b-form-input v-else type="text" id="input-konto_destinacije" :value="itemData.konto_destinacije" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-koda_prod">Koda prod.</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-koda_prod" v-model="itemData1.koda_prod"></b-form-input>
								<b-form-input v-else type="text" id="input-koda_prod" :value="itemData.koda_prod" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group label="Datum dodelitve" label-for="input-dejanski_datum_dodelitve">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="dejanski_datum_dodelitve"
									id="input-dejanski_datum_dodelitve"
									v-model="itemData1.dejanski_datum_dodelitve"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-dejanski_datum_dodelitve" :value="itemData.dejanski_datum_dodelitve" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group label="Datum stornacije" label-for="input-dejanski_datum_stornacije">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="dejanski_datum_stornacije"
									id="input-dejanski_datum_stornacije"
									v-model="itemData1.dejanski_datum_stornacije"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-dejanski_datum_stornacije" :value="itemData.dejanski_datum_stornacije" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-tip_kupca">Tip kupca</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-tip_kupca" v-model="itemData1.tip_kupca"></b-form-input>
								<b-form-input v-else type="text" id="input-tip_kupca" :value="itemData.tip_kupca" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-prodajni_kanal">Prodajni kanal</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-prodajni_kanal" v-model="itemData1.prodajni_kanal"></b-form-input>
								<b-form-input v-else type="text" id="input-prodajni_kanal" :value="itemData.prodajni_kanal" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-tip_nm">Tip NM</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-tip_nm" v-model="itemData1.tip_nm"></b-form-input>
								<b-form-input v-else type="text" id="input-tip_nm" :value="itemData.tip_nm" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-ime">Ime</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-ime" v-model="itemData1.ime"></b-form-input>
								<b-form-input v-else type="text" id="input-ime" :value="itemData.ime" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-email">Email</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-email" v-model="itemData1.email"></b-form-input>
								<b-form-input v-else type="text" id="input-email" :value="itemData.email" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-telefon_privatni">Telefon</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-telefon_privatni" v-model="itemData1.telefon_privatni"></b-form-input>
								<b-form-input v-else type="text" id="input-telefon_privatni" :value="itemData.telefon_privatni" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-st_pogodbe_v_advensysu">Št. pogodbe</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-st_pogodbe_v_advensysu" v-model="itemData1.st_pogodbe_v_advensysu"></b-form-input>
								<b-form-input v-else type="text" id="input-st_pogodbe_v_advensysu" :value="itemData.st_pogodbe_v_advensysu" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-stanje_narocila_kupca">Stanje naročila kupca</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-stanje_narocila_kupca" v-model="itemData1.stanje_narocila_kupca"></b-form-input>
								<b-form-input v-else type="text" id="input-stanje_narocila_kupca" :value="itemData.stanje_narocila_kupca" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-status_kvalitete">Status kvalitete</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-status_kvalitete" v-model="itemData1.status_kvalitete"></b-form-input>
								<b-form-input v-else type="text" id="input-status_kvalitete" :value="itemData.status_kvalitete" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group label="Realni ara" label-for="input-realni_ara">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="realni_ara"
									id="input-realni_ara"
									v-model="itemData1.realni_ara"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-realni_ara" :value="itemData.realni_ara" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-nef">NEF</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-nef" v-model="itemData1.nef"></b-form-input>
								<b-form-input v-else type="text" id="input-nef" :value="itemData.nef" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-ddo">DDO</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-ddo" v-model="itemData1.ddo"></b-form-input>
								<b-form-input v-else type="text" id="input-ddo" :value="itemData.ddo" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-ddpp">DDPP</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-ddpp" v-model="itemData1.ddpp"></b-form-input>
								<b-form-input v-else type="text" id="input-ddpp" :value="itemData.ddpp" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group>
								<label for="input-blocage_financier">Blocage financier</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-blocage_financier" v-model="itemData1.blocage_financier"></b-form-input>
								<b-form-input v-else type="text" id="input-blocage_financier" :value="itemData.blocage_financier" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-blokada_komerciale">Blokada komericale</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-blokada_komerciale" v-model="itemData1.blokada_komerciale"></b-form-input>
								<b-form-input v-else type="text" id="input-blokada_komerciale" :value="itemData.blokada_komerciale" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-blokada_cata">Blokada cata</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-blokada_cata" v-model="itemData1.blokada_cata"></b-form-input>
								<b-form-input v-else type="text" id="input-blokada_cata" :value="itemData.blokada_cata" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label for="input-blokada_kvalitete">Blokada kvalitete</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-blokada_kvalitete" v-model="itemData1.blokada_kvalitete"></b-form-input>
								<b-form-input v-else type="text" id="input-blokada_kvalitete" :value="itemData.blokada_kvalitete" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="4">
							<b-form-group>
								<label for="input-pgeo_bcv">Pgeo bcv</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-pgeo_bcv" v-model="itemData1.pgeo_bcv"></b-form-input>
								<b-form-input v-else type="text" id="input-pgeo_bcv" :value="itemData.pgeo_bcv" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-zadrzano_lastnik">Zadrzano lastnik</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-zadrzano_lastnik" v-model="itemData1.zadrzano_lastnik"></b-form-input>
								<b-form-input v-else type="text" id="input-zadrzano_lastnik" :value="itemData.zadrzano_lastnik" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="4">
							<b-form-group>
								<label for="input-akcijski">Akcijski</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-akcijski" v-model="itemData1.akcijski"></b-form-input>
								<b-form-input v-else type="text" id="input-akcijski" :value="itemData.akcijski" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="3">
							<b-form-group>
								<label for="input-koncesija_lokacija">Koncesija lokacija</label>
								<b-form-input v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" type="text" id="input-koncesija_lokacija" v-model="itemData1.koncesija_lokacija"></b-form-input>
								<b-form-input v-else type="text" id="input-koncesija_lokacija" :value="itemData.koncesija_lokacija" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group>
								<label>Koncesija prodajalec</label>
								<v-select v-if="nacin === NACIN_DODAJANJA" ref="prodajalci"
									v-model="prodajalci_selected"
									:options="vsiProdajalci"
									label="full_name"
									placeholder="Izberi prodajalca ...">
								</v-select>
								<b-form-input v-else-if="nacin === NACIN_UREJANJA" type="text" id="input-koncesija_prodajalec" :value="itemData1.koncesija_prodajalec" disabled></b-form-input>
								<b-form-input v-else type="text" id="input-koncesija_prodajalec" :value="itemData.koncesija_prodajalec" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Koncesija datum" label-for="input-koncesija_datum">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="koncesija_datum"
									id="input-koncesija_datum"
									v-model="itemData1.koncesija_datum"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-koncesija_datum" :value="itemData.koncesija_datum" readonly></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Datum izhoda iz oc" label-for="input-datum_izhoda_iz_oc">
								<v-date-picker v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA"
									ref="datum_izhoda_iz_oc"
									id="input-datum_izhoda_iz_oc"
									v-model="itemData1.datum_izhoda_iz_oc"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
								<b-form-input v-else type="text" id="input-datum_izhoda_iz_oc" :value="itemData.datum_izhoda_iz_oc" readonly></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-form-group>
						<label for="input-interna_opomba">Interna opomba</label>
						<b-form-textarea v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" id="input-interna_opomba" :rows="2" :max-rows="6" v-model="itemData1.interna_opomba"></b-form-textarea>
						<b-form-textarea v-else id="input-interna_opomba" :rows="2" :max-rows="6" :value="itemData.interna_opomba" readonly></b-form-textarea>
					</b-form-group>
					<b-form-group>
						<label for="input-opomba_narocilo_kupca">Opomba naročila kupca</label>
						<b-form-textarea v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" id="input-opomba_narocilo_kupca" :rows="2" :max-rows="6" v-model="itemData1.opomba_narocilo_kupca"></b-form-textarea>
						<b-form-textarea v-else id="input-opomba_narocilo_kupca" :rows="2" :max-rows="6" :value="itemData.opomba_narocilo_kupca" readonly></b-form-textarea>
					</b-form-group>
				</b-tab>
			</form>
		</b-tabs>
		<b-alert class="error_message" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button v-if="nacin === NACIN_DODAJANJA || nacin === NACIN_UREJANJA" variant="secondary" @click="modal_cancelClick($event)">Prekliči</b-button>
						<b-button ref="aOk" variant="primary" data-style="zoom-in" :disabled="!vozilo_arhivirano" @click.stop="modal_okClick($event)">
							<span class="ladda-label">{{ ok_text }}</span>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
.ma_pos {
	text-align: end;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.text_red {
	color: #f86c6b;;
}
</style>
<style>
</style>


// WEBPACK FOOTER //
// src/components/PodrobnostiVozilaModal.vue